import React from 'react';
import styles from './ApexCollegeofPharmacy.module.css';
// Add a photo of Mrs. Swarnima Pandey to your project's image folder


const ApexCollegeofPharmacy = () => {
    // Data from the new pharmacy programs table
    const pharmacyPrograms = [
        { 
            program: 'Diploma in Pharmacy', 
            duration: '2 Years', 
            eligibility: '10+2 (Science stream) with required minimum marks*', 
            approval: '[Details as per university/PCI]' 
        },
        { 
            program: 'Bachelor of Pharmacy', 
            duration: '4 Years', 
            eligibility: '10+2 (Science stream) with required minimum marks*', 
            approval: '[Details as per university/PCI]' 
        }
    ];

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>Apex College of Pharmacy</h1>
                <p>Apex College of Pharmacy is envisioned as a leading center of excellence for Pharmaceutical Sciences in North India, dedicated to advancing global healthcare through a multidisciplinary, industry-oriented approach.</p>
            </header>

            <section className={styles.principalMessage}>
                {/* <div className={styles.principalImageContainer}>
                    <img src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1755455088/apex/e9475a83-7f34-48a1-8fa1-825c11048bdc.png" alt="Mrs. Swarnima Pandey, Principal" className={styles.principalImage} />
                </div> */}
                <div className={styles.principalText}>
                    <h2>Message from the Principal’s Desk</h2>
                    <p>Today, healthcare is recognized as not only treating illness but also promoting and maintaining overall well-being. The COVID-19 pandemic has shown the world the critical need for a robust healthcare system.</p>
                    <p>At Apex, we are committed to imparting quality healthcare education. Through regular industry, hospital, and laboratory visits, we ensure our students gain hands-on experience and develop into outstanding pharmacy professionals.</p>
                    {/* <h4>Mrs. Swarnima Pandey</h4> */}
                    <p> <br/>Principal, Apex College of Pharmacy</p>
                </div>
            </section>

            <section className={styles.programsOffered}>
                <h2>Programs Offered</h2>
                <div className={styles.tableContainer}>
                    <table className={styles.programsTable}>
                        <thead>
                            <tr>
                                <th>Program</th>
                                <th>Duration</th>
                                <th>Eligibility</th>
                                <th>Affiliation(s)/Approval</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pharmacyPrograms.map((program, index) => (
                                <tr key={index}>
                                    <td data-label="Program">{program.program}</td>
                                    <td data-label="Duration">{program.duration}</td>
                                    <td data-label="Eligibility">{program.eligibility}</td>
                                    <td data-label="Approval">{program.approval}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <p className={styles.eligibilityNote}>*Refer to official notifications for minimum eligibility and reservation criteria.</p>
            </section>
            
            <section className={styles.advantages}>
                <h2>Advantages of Pharmacy Course at Apex</h2>
                 <ul>
                    <li><strong>Real-Time Practical Training:</strong> Extensive hands-on experience in modern laboratories.</li>
                    <li><strong>Research Orientation:</strong> Focused skill enrichment to cultivate a scientific and investigative mindset.</li>
                    <li><strong>Expert Pedagogy:</strong> Courses led by seasoned doctorate faculty.</li>
                    <li><strong>Industry Exposure:</strong> Regular industrial visits, IPR training, and strong industry connections.</li>
                    <li><strong>Innovation-Driven Environment:</strong> Supportive atmosphere for creativity, innovation, and entrepreneurship.</li>
                    <li><strong>Entrepreneurial Development:</strong> Initiatives and mentorship for leadership and enterprise qualities.</li>
                </ul>
            </section>

            <section className={styles.uniqueFeatures}>
                <h2>Unique Features</h2>
                <ul>
                    <li><strong>Cutting-Edge Laboratories:</strong> Well-equipped labs for all core and emerging areas of pharmaceutical science.</li>
                    <li><strong>Experienced Faculty:</strong> Doctorate and research-oriented teachers with academic and industry credentials.</li>
                    <li><strong>Collaborative Learning:</strong> Group projects, seminars, and interactive workshops.</li>
                    <li><strong>Industry Connect:</strong> Regular interface with pharma industry leaders and practitioners.</li>
                    <li><strong>Research & Innovation Hub:</strong> Opportunities for student participation in research projects and conferences.</li>
                    <li><strong>Support for Competitive Exams:</strong> Guidance for GPAT, government jobs, and higher research degrees.</li>
                </ul>
            </section>

            <footer className={styles.footer}>
                <h3>Contact Information</h3>
                <p><strong>General Inquiries:</strong> +91-7351408009</p>
                <p><strong>Email:</strong> admissions@apex.in</p>
                <p className={styles.note}>
                    Note: Program details, eligibility, and fee structure are updated regularly. Prospective students are encouraged to verify current offerings and guidelines before applying.
                </p>
            </footer>
        </div>
    );
};

export default ApexCollegeofPharmacy;